import { render, staticRenderFns } from "./ShowPosts.vue?vue&type=template&id=34a14d4a&scoped=true"
import script from "./ShowPosts.vue?vue&type=script&lang=js"
export * from "./ShowPosts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a14d4a",
  null
  
)

export default component.exports